import script from "./order-group.vue?vue&type=script&setup=true&lang=js"
export * from "./order-group.vue?vue&type=script&setup=true&lang=js"

import "./order-group.vue?vue&type=style&index=0&id=661f33be&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-661f33be"]])

export default __exports__